<template>
  <div>
    <div v-if="showReplaceCompanyBtn" class="f_14 color_blue cursor_p" @click="open()"><span class="iconfont iconqiehuan color_blue"></span>更换公司</div>
    <el-dialog
      width="446px"
      title="更换绑定公司"
      :visible.sync="toastVisible"
      :show-close="false"
      :close-on-click-modal="false">
      <span class="color_60 f_14">更换绑定公司后将下线全部线上职位，是否要继续更换？</span>
      <span slot="footer" class="dialog-footer">
        <button class="cancel" @click="toastVisible = false">取消</button>
        <button class="bg_current border_current confirm" type="primary" @click="toastConfirm()">确定</button>
      </span>
    </el-dialog>
    <el-dialog
      width="446px"
      title="认证失败"
      :visible.sync="sMessageBoxState"
      :show-close="true"
      :close-on-click-modal="false">
      <span class="color_60 f_14 lh20">请使用正规邮箱进行员工身份的认证，或者通过上传营业执照进行认证</span>
      <span slot="footer" class="dialog-footer">
        <button class="cancel" @click="sMessageBoxState = false">修改邮箱</button>
        <button class="bg_current border_current confirm btn-padding" type="primary" @click="toCompanyAudit">上传营业执照</button>
      </span>
    </el-dialog>
    <el-dialog
      width="446px"
      title="更换绑定公司"
      :visible.sync="dialogVisible"
      :show-close="false"
      :close-on-click-modal="false">
      <el-form :model="form" label-position="left">
        <el-form-item label="*公司名称：" :label-width="formLabelWidth">

          <el-autocomplete  class="restInput f_14 color_40" 
                            size="normal" 
                            popper-class="searchCompany" 
                            :maxlength="20" 
                            placeholder="请输入您所属公司营业执照上的公司名称" 
                            v-model="form.company" 
                            :fetch-suggestions="companySearch" 
                            @select="handleCompany" 
                            @focus="inputFocus('company')"
                           >
            <template slot-scope="{item}">
              <div class="name" v-if="item.full_name.length">
                <template v-if="item.full_name.length===1 && searchIngCompanyList[item.index].full_name===form.company">
                  <span class='es-highlighter'>{{item.full_name[0]}}</span>
                </template>
                <template v-else-if="searchIngCompanyList[item.index].full_name.indexOf(form.company) >-1">
                  <span v-for="(sitem,sindex) in item.full_name" :key="String(sindex)"><span class='es-highlighter' v-if="sindex == item.full_name.length-1">{{form.company}}</span>{{sitem}}</span>
                </template>
                <template v-else>
                  {{item.full_name[0]}}
                </template>
              </div>
              <div class="name" v-else>
                <span class='es-highlighter'>{{form.company}}</span>
              </div>
            </template>
          </el-autocomplete>
          <!-- 错误提示 -->
          <div class="errorTipsDesc f_14" v-if="errorTips.company">
            <span class="iconfont icontishi"></span>
            <span class="tipsName">{{errorTips.company}}</span>
          </div>

        </el-form-item>

        <el-form-item label="*公司邮箱：" :label-width="formLabelWidth">
          <el-input class="restInput f_14 color_40" v-model="form.email" placeholder="输入您用于接收简历的公司邮箱" size="normal" autocomplete="off" @focus="inputFocus('email')" :maxlength="64"></el-input>
          <!-- 错误提示 -->
          <div class="errorTipsDesc f_14" v-if="errorTips.email">
            <span class="iconfont icontishi"></span>
            <span class="tipsName">{{errorTips.email}}</span>
          </div>

        </el-form-item>

        <el-form-item label="*验证码：" :label-width="formLabelWidth">
          <div class="codeBox flex-c">
            <el-input class="restInput f_14 color_40" v-model="form.code" placeholder="输入验证码" size="normal" autocomplete="off"  @focus="inputFocus('code')" :maxlength="6"></el-input>
            <div class="time cursor_p text_center f_14">
              <span class="color_blue" @click="getEmailCode()" v-if="emailData.time === 60">发送验证码</span>
              <span class="color_90" v-else >{{emailData.time}}s</span>
            </div>
          </div>
          <!-- 错误提示 -->
          <div class="errorTipsDesc f_14" v-if="errorTips.code">
            <span class="iconfont icontishi"></span>
            <span class="tipsName">{{errorTips.code}}</span>
          </div>

        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <button class="cancel" @click="cancel()">取消</button>
        <button class="bg_current border_current confirm" type="primary" @click="confirm()">确定</button>
      </span>
    </el-dialog>
    <!-- <MessageBox :pageData="sMessageBoxData" v-if="sMessageBoxState" @close="sMessageBoxState = false;" @confirmButton="toCompanyAudit(true)" @cancelButton="bindEmailCreatedHr('edit')" /> -->
  </div>
</template>

<script>
import actions from '@/actions/index'
import { updateJWT } from '@/utils/utils'
import { mapState, mapMutations } from 'vuex'
// import MessageBox from '@/components/block/MessageBox'
export default {
  props: {
    showReplaceCompanyBtn: {
      type: Boolean,
      default: false
    }
  },
  components:{
    // MessageBox
  },
  data () {
    return {
      // 输入表单
      form: {
        company: null,
        token: null,
        email: null,
        code: null
      },
      // 表单错误提示集合
      errorTips:{
        company: null,
        email: null,
        code: null
      },
      // 邮箱验证码data
      emailData: {
        time: 60,
        timeName: null,
        getCodeState: false
      },
      // 自动补全公司列表
      searchIngCompanyList: [],
      // 不可以输入的邮箱
      cannotEmail:['@qq.com', '@163.com', '@126.com', '@gmail', 'outlook.com', '@hotmail.com', '.edu', '@sohu.com', '@sina.com'],
      // 表单label宽度
      formLabelWidth: '98px',
      // 第一个弹窗（用来提示）
      toastVisible: false,
      // 第二个弹窗（用来输入）
      dialogVisible: false,
      // 询问弹框显示
      sMessageBoxState: false,
      // 询问弹框
      sMessageBoxData:{
        title:'认证失败',
        desc:'请使用正规邮箱进行员工身份的认证，或者通过上传营业执照进行认证',
        confirmText:'上传营业执照',
        cancelText:'修改邮箱',
        // confirmButtonBg: '#FF6644',
        showClose: true
      },
      isLoading: false,
    }
  },
  computed: {
    ...mapState('block', ['userInfo'])
  },
  created () {
    let { showReplaceDialog } = this.$route.params
    if (showReplaceDialog) {
      this.open()
    }
  },
  methods: {
    ...mapMutations('block',['toggleUserInfoState']),
    open() {
      this.toastVisible = true
    },
    toastConfirm () {
      this.toastVisible = false
      this.dialogVisible = true
    },
    // 去公司审核
    toCompanyAudit(){
      let { href } = this.$router.resolve({
        path: '/talent/binduser',
        query: {fromEditUserInfo: true, email: encodeURIComponent(this.form.email)}
      })
      this.dialogVisible = false
      window.open(href,'_blank')
    },
    //【公司】搜索公司名称
    companySearch(queryString, cb) {
      queryString = queryString ? queryString.trim() : ''
      this.form.company = queryString
      cb([])
      if(!queryString){
        return false
      }
      let query = {
        from: 0,
        size: 30,
        keyword: queryString
      }
      actions.company.get_company_name(query).then(res=>{
        if(res.code === 1000){
          let { companies } = res.data
          this.searchIngCompanyList = JSON.parse(JSON.stringify(companies));
          //防止同指针，污染 searchIngCompanyList
          let companyList = [...companies]
          //拆分数据
          companyList.forEach((item,index)=>{
            let name = [item.full_name]
            if(item.full_name.indexOf(queryString)>-1){
              name = item.full_name.split(queryString).filter(sitem => sitem)
            }
            item.index = index
            item.full_name = name
          })
          console.log(companyList)
          // 调用 callback 返回建议列表的数据
          cb(companyList)
        }
      })
    },
    //【公司】点击城市筛选项
    handleCompany(item) {
      this.form.company = this.searchIngCompanyList[item.index].full_name
      this.form.token = this.searchIngCompanyList[item.index].token
    },
    //【公司】失焦，如果匹配不上，直接情况输入框
    companyBlur(){
      let company = this.form.company ? this.form.company.trim() : '';
      let hasCompany = false;
      if(!company){
        this.form.company = ''
        return false;
      }
      this.searchIngCompanyList.forEach(item=>{
        if(item.full_name === company){
          hasCompany = true;
        }
      })
      if(!hasCompany){
        this.form.company = '';
      }
    },
    //取消错误提示
    inputFocus(type){
      this.errorTips[type] = ''
    },
    //【邮箱】获取验证码
    getEmailCode(){
      //防抖
      if(this.emailData.getCodeState){
        return false;
      }
      //对电子邮件的验证
      var myreg = /^([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\-|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,10}$/;
      // let hasCannotEmail = false;
      // this.cannotEmail.forEach(item=>{
      //   if(this.form.email.indexOf(item)>-1){
      //     hasCannotEmail = true;
      //   }
      // })
      if(!myreg.test(this.form.email)){
        this.errorTips.email = '请填写有效的公司邮箱';
        return false;
      }
      this.emailData.getCodeState = true;
      let data={
        receiver: this.form.email,
        type: 'email',
        source: 'audit'
      }
      //发送验证码
      actions.hr_accounts.verification_codes(data).then(res=>{
        if(res.code === 1000){
          this.$message({
            message: '邮箱验证码已发送',
            type: 'success'
          });
          this.emailData.time = 59;
          this.codeTime();
        }else{
          this.emailData.getCodeState = false;
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      })
    },
    //【邮箱】倒计时
    codeTime(){
      this.emailData.timeName = setInterval(() => {
        if(this.emailData.time == 1){
          clearInterval(this.emailData.timeName);
          this.emailData.time = 60;
          this.emailData.getCodeState = false;
          return false;
        }
        this.emailData.time = this.emailData.time-1;

      }, 1000);
    },
    // 取消
    cancel () {
      this.dialogVisible = false
      this.resetForm()
    },
    // 确认
    async confirm () {
      let flag = true
      if (!this.form.company) {
        this.errorTips.company = '请填写公司名称'
        flag = false
      }
      if (!this.form.email) {
        this.errorTips.email = '请填写公司邮箱'
        flag = false
      }
      if (!this.form.code) {
        this.errorTips.code = '请填写验证码'
        flag = false
      }
      // 没有通过校验，不调接口
      if (!flag) return false
      // 防抖
      if(this.isLoading) return 
      let params = {
        name: this.userInfo.name,
        company_name: this.form.company,
        company_position: this.userInfo.company_position,
        company_token: this.form.token,
        // company_email: this.form.email,
        // email_code: this.form.code,
        source: "pc_browser",
        id: this.userInfo.id
      }
      this.isLoading = true
      let loading = this.$message({
        iconClass: 'el-icon-loading',
        message: '加载中'
      })
      // 保存用户信息以及邮箱校验
      let res = await actions.hr_accounts.audition_email({
        company_name: this.form.company,
        name: this.userInfo.name,
        profession: this.userInfo.company_position,
        email: this.form.email,
        code: this.form.code
      })
      loading.close()
      this.isLoading = false
      if(res.code === 1000 && res.data && res.data.message === '公司不在数据库') {
        // 去公司审核页
        this.toCompanyAudit()
      } else if(res.code !== 1000 && (res.message === '非企业邮箱' || res.message === '邮箱格式有误')){
        // 修改邮箱或者去审核页
        this.sMessageBoxState = true
      } else if(res.code === 1000 && res.message === '成功') {
        this.$message.success('绑定成功')
        // 关闭绑定邮箱弹层
        this.dialogVisible = false
        // 更换为同一家公司不下线线上职位
        if (this.form.token !== this.userInfo.company_token) {
          // hr更换公司后下线之前线上职位
          try {
            await actions.hr_accounts.offlineJobStatus()
          } catch (e) { console.log(e) }
        }
        // 更新公司信息
        this.$emit('updateCompanyInfo', this.form.token)
        actions.hr_accounts.getUserinfo().then(userInfo => {
          this.toggleUserInfoState(userInfo)
        })         
      } else if(res.code === 2009) {
        this.$message.error('验证码不正确')
      }
      if(res.code !== 1000 && res.code !== 2009) {
        this.$message.error('出错了')
      }
      // try {
      //   let res = await actions.hr_accounts.update_user(params)
      //   if (res.code === 1000) {
      //     let { jwt, jwt_timestamp } = res.data
      //     await updateJWT({
      //       jwt,
      //       jwt_timestamp: jwt_timestamp
      //     })
      //     this.$message({
      //       message: '更换绑定公司成功',
      //       type: 'success'
      //     })
      //     // 关闭绑定邮箱弹层
      //     this.dialogVisible = false
      //     // 更换为同一家公司不下线线上职位
      //     if (this.form.token !== this.userInfo.company_token) {
      //       // hr更换公司后下线之前线上职位
      //       try {
      //         await actions.hr_accounts.offlineJobStatus()
      //       } catch (e) { console.log(e) }
      //     }
      //     // 更新公司信息
      //     this.$emit('updateCompanyInfo', this.form.token)
      //     // 更新用户信息
      //     try {
      //       let userInfo = await actions.hr_accounts.getUserinfo()
      //       this.toggleUserInfoState(userInfo)
      //     } catch (e) { console.log(e) }
      //     // 重置表单
      //     this.resetForm()
      //   } else {
      //     this.$message({
      //       message: res.message,
      //       type: 'error'
      //     })
      //   }
      // } catch (error) {
      //   console.log(error)
      // }

    },
    // 重置表单
    resetForm () {
      clearInterval(this.emailData.timeName)
      this.form = { company: null, token: null, email: null, code: null }
      this.errorTips = { company: null, email: null, code: null}
      this.emailData = { time: 60, timeName: null, getCodeState: false}
      this.searchIngCompanyList = []
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep input {
    border-color: #ECECEC !important;
    &:hover,
    &:focus {
      border-color: #ECECEC !important;
    }
  }
  ::v-deep .el-form-item__label {
    color: #9C9C9C;
  }
  ::v-deep .el-dialog__title {
    color: #404040;
    font-size: 18px;
    font-weight: 500;
  }
  button {
    line-height: 36px;
    text-align: center;
    padding: 0;
    width: 84px;
    height: 36px;
    border-radius: 2px;
    box-sizing: border-box;
    &.cancel {
      color: #606060;
      border: 1px solid #D9D9D9;
      background-color: #ffffff;
      margin-right: 16px;
      line-height: 34px;
      &:hover {
        color: #606060;
        opacity: 0.8;
      }
    }
    &.confirm {
      color: #FFFFFF;
      &:hover {
        opacity: 0.8;
      }
    }
  }

  .errorTipsDesc {
    color: #FD5F39;
    line-height: 24px;

    .tipsName {
      margin-left: 8px;
    }
  }

  .codeBox {
    height: 46px;
    border-radius: 2px;
    border: 1px solid #ECECEC;

    ::v-deep input {
      border: 0;
    }

    .time {
      padding: 0 10px;
      line-height: 22px;
      height: 22px;
      width: 110px;
      border-left: 1px solid #ECECEC;
    }
  }

  .iconqiehuan {
    margin-right: 4px;
  }
  .lh20{
    line-height: 20px;
  }
  .btn-padding{
    padding: 0 8px;
    box-sizing: content-box;
  }
</style>
